<div class="postmortem-wrapper" [formGroup]="postmortemForm">
  @if (isLoading) {
    <div class="postmortem-skeleton">
      <div class="skeleton-line w-40"></div>
      <div class="skeleton-line w-60"></div>

      <div class="skeleton-box tall"></div>
      <div class="skeleton-box tall"></div>
      <div class="skeleton-box tall"></div>
      <div class="skeleton-box tall-sm"></div>

      <div class="skeleton-box"></div>
    </div>
  } @else {
    @if (showPublishSection && isPublished) {
      <div class="published-banner">
        <mat-icon class="material-symbols-outlined">public</mat-icon>
        Published — visible on public status page
      </div>
    }

    <div class="postmortem-header">
      <div class="section-title">POST-MORTEM REPORT</div>
      <div class="section-subtitle">Document findings, root cause, and action items.</div>
    </div>

    @if (showEmptyStateNote) {
      <div class="postmortem-empty-note">
        No post-mortem has been created for this incident yet. Use the fields below to add one.
      </div>
    }

    <div class="postmortem-form">
      @for (section of postmortemSections; track section.key) {
        <section class="postmortem-field-card" [class.is-editing]="isEditingField(section.key)">
          <div class="postmortem-field-header">
            <div class="postmortem-field-title">
              <span class="postmortem-field-dot" aria-hidden="true"></span>
              <span>{{ section.label }}</span>
              @if (section.key === 'summary') {
                <span class="summary-publish-note">Required for publishing</span>
              }
            </div>

            @if (isEditingField(section.key)) {
              <div class="postmortem-edit-actions">
                <button
                  type="button"
                  class="postmortem-action-btn finish-edit"
                  mat-icon-button
                  (click)="finishEditField(section.key)"
                  [disabled]="isSaving || isPublishing || isDeleting"
                  aria-label="Done editing">
                  <mat-icon>done</mat-icon>
                </button>
                <button
                  type="button"
                  class="postmortem-action-btn cancel-edit"
                  mat-icon-button
                  (click)="cancelEditField(section.key)"
                  [disabled]="isSaving || isPublishing || isDeleting"
                  aria-label="Cancel edit">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            } @else {
              <button
                mat-button
                type="button"
                class="btn-link postmortem-edit-btn"
                color="primary"
                (click)="startEditField(section.key)"
                [disabled]="isSaving || isPublishing || isDeleting || editingField">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                EDIT
              </button>
            }
          </div>

          @if (isEditingField(section.key)) {
            <div class="error-input-wrapper">
              <quill-editor
                class="d-flex flex-column messagefield"
                [modules]="messageEditorModules"
                [formControlName]="section.key"
                theme="snow"
                [placeholder]="section.placeholder"
                (onContentChanged)="onContentChanged()">
              </quill-editor>
              @if (isFieldInvalid(section.key)) {
                <mat-error>
                  {{ section.label }} is invalid
                </mat-error>
              }
            </div>
          } @else {
            <div class="postmortem-readonly-content" [class.is-empty]="!hasFieldValue(section.key)">
              @if (hasFieldValue(section.key)) {
                <div class="postmortem-readonly-rich-text" [innerHTML]="getFieldValue(section.key) | statusPageRichText"></div>
              } @else {
                <span>{{ section.emptyText }}</span>
              }
            </div>
          }
        </section>
      }
    </div>

    @if (showPublishSection) {
      <div class="publish-section">
        <div class="publish-card">
          <div class="publish-info">
            @if (!isPublished) {
              <div class="publish-title">Unpublished</div>
              <div class="publish-subtitle">Only visible to admins — not shown publicly</div>
            } @else {
              <div class="publish-title">Published</div>
              <div class="publish-subtitle">Visible to subscribers on the public status page</div>
            }
          </div>
          <div class="publish-actions">
            <span class="publish-status-chip" [class.published]="isPublished" [class.unpublished]="!isPublished">
              <span class="publish-status-dot" aria-hidden="true"></span>
              {{ isPublished ? 'Published' : 'Unpublished' }}
            </span>
            @if (!isPublished) {
              <span
                class="publish-action-tooltip"
                [class.summary-missing]="!hasPublishableSummary"
                [matTooltip]="!hasPublishableSummary ? 'Summary is required for publishing' : ''"
                [matTooltipDisabled]="hasPublishableSummary"
                matTooltipPosition="above">
                <button type="button" class="publish-btn publish-action" mat-raised-button (click)="publishPostmortem()" [disabled]="!canPublishPostmortem">
                  <mat-icon class="material-symbols-outlined">public</mat-icon>
                  Publish
                </button>
              </span>
            } @else {
              <button type="button" class="publish-btn unpublish-action" mat-raised-button (click)="unpublishPostmortem()" [disabled]="isSaving || isPublishing || isDeleting">
                <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>
                Unpublish
              </button>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
